import React from 'react'
import { ModelWithForm, WhenLoaded } from '@morningtrain/react-resources'
import RefreshEmploymentsOnPipe from 'pages/app/hr/employments/partials/RefreshEmploymentsOnPipe'
import { MountSmartviewOnPipe } from '@morningtrain/react-smartviews'
import EmploymentSmartviewInner from 'pages/app/hr/employments/smartviews/EmploymentSmartviewInner'

export default function EmploymentSmartview ({ create = false, id = null }) {
  return (
    <ModelWithForm resourceName='employments.employment' id={id}>
      <RefreshEmploymentsOnPipe />
      <MountSmartviewOnPipe
        smartview={payload => <EmploymentSmartview id={payload.response.model.id} />}
        replace={false}
      />
      <WhenLoaded>
        <EmploymentSmartviewInner create={create} />
      </WhenLoaded>
    </ModelWithForm>
  )
}
